import { Box, keyframes } from "@mui/material";

const shimmer = keyframes`
  0% { transform: translateX(-100%); }
  100% { transform: translateX(100%); }
`;

const Loader = () => {
  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        zIndex: 2000,
        width: "100%",
        height: 4,
        bgcolor: 'rgba(99, 102, 241, 0.1)',
        overflow: 'hidden'
      }}
    >
      <Box
        sx={{
          width: "100%",
          height: "100%",
          background: 'linear-gradient(90deg, transparent, #6366f1, #a855f7, transparent)',
          animation: `${shimmer} 1.5s infinite linear`,
          boxShadow: '0 0 8px #6366f1'
        }}
      />
    </Box>
  );
};

export default Loader;
